import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Campaign, CampaignTargetUser } from 'src/app/api/api-campaigns.service.generated';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { LoadingOverlayComponent } from 'wecheer-common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-target-role-tab',
  templateUrl: './target-role-tab.component.html',
  styleUrls: ['./target-role-tab.component.scss'],
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    LoadingOverlayComponent,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class TargetRoleTabComponent {

  @Input() campaign: Campaign;
  @Output() onTargetRoleChanged: EventEmitter<any> = new EventEmitter();

  form = new FormGroup ({
    targetRoleSelect: new FormControl('', Validators.required),
  });

  targetRole: CampaignTargetUser;
  targetRoles = [
    {
      value: CampaignTargetUser.Consumer,
      label: 'Consumer',
    },
    {
      value: CampaignTargetUser.Staff,
      label: 'Staff',
    }
  ]

  isLoading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.campaign && changes.campaign.currentValue) {
      this.targetRole = this.campaign.targetUser || CampaignTargetUser.Consumer; // Default to Consumer if not set
      this.form.patchValue({
        targetRoleSelect: this.targetRole
      });
      this.onTargetRoleChanged.emit(this.targetRole);
    }
  }

  onTargetRoleChange(ev: any) {
    this.targetRole = ev.value;
    this.onTargetRoleChanged.emit(ev.value);
  }

  isValid() {
    this.form.get('targetRoleSelect').markAsTouched();
    return this.form.valid;
  }

  // Add getter to check if Consumer is selected
  get isConsumerSelected(): boolean {
    return this.targetRole === CampaignTargetUser.Consumer;
  }

}
